import { createSelector } from '@ngrx/store';

import { SearchAllParamsStore, SearchAllRootStore } from './interfaces/search-all-store.interface';

export const getSearchAllParams = (store: SearchAllRootStore): SearchAllParamsStore => {
    return store.searchAllParams;
};
export const getSearchTypes = createSelector(getSearchAllParams, (params) => params.searchTypes);

export const getQueryInput = createSelector(getSearchAllParams, (params) => params.queryInput);

export const getCategoryPageNum = createSelector(getSearchAllParams, (params) => params.searchCategoryPageNum);
